import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const UnorderedList = (props) => (
  <Icon viewBox="0 0 30 30" {...props}>
    <g>
      <path d="M13 23h10v-2H13v2zm-5 0h3v-3H8v3zm0-6h3v-3H8v3zm0-6h3V8H8v3zm5 0h10V9H13v2zm0 6h10v-2H13v2z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default UnorderedList;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/UnorderedList.js